import PropTypes from "prop-types"
import { identity } from "lodash"
import { IconButton, Grid } from "@mui/material"
import { ExpandMore } from "@mui/icons-material"
import { VALUE } from "./shape"

export default function TitleRow({ label, rebalanced, original, delta, formatter = identity, color = "", fixed, onClick }) {
  return (
    <Grid container className="panel-row title-row" onClick={onClick}>
      <Grid container className="metric">
        <span className="label" style={{ color }}>{label}</span>
        {!fixed && <IconButton size="small" className="expand-icon" component="div" tabIndex={-1}><ExpandMore /></IconButton>}
      </Grid>
      <Grid container className="values">
        <div className="optimizer">{formatter(rebalanced)}</div>
        <div className="original">{formatter(original)}</div>
        <div className="delta">{formatter(delta)}</div>
      </Grid>
    </Grid>
  )
}

TitleRow.propTypes = {
  label: PropTypes.string,
  rebalanced: VALUE,
  original: VALUE,
  delta: VALUE,
  color: PropTypes.string,
  fixed: PropTypes.bool,
  formatter: PropTypes.func,
  onClick: PropTypes.func,
}
